export default "__VITE_ASSET__DdrvAjOb__"